import { createApi } from '@reduxjs/toolkit/query/react';
import { List } from 'immutable';
import Reason from 'models/ValueProposition/Reason';
import { axiosBaseQuery } from 'services/api';
import { byId } from 'store/utils/sortFunctions';

const REASON_TAG = 'ValuePropositionReason';

// API slice for Value Proposition / Reasons
export const valuePropositionReasonsApi = createApi({
  reducerPath: 'valuePropositionReasonsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: [REASON_TAG],
  endpoints: builder => ({
    // Returns undefined during loading or a List of Reason instances sorted by id
    listReasons: builder.query({
      query: params => ({
        url: '/api/reasons/',
        params,
      }),
      transformResponse: response =>
        List(Array.isArray(response) ? response.map(reason => new Reason(reason)).sort(byId) : []),
      providesTags: [REASON_TAG],
    }),
    fetchReason: builder.query({
      query: id => ({
        url: `/api/reasons/${id}/`,
      }),
      transformResponse: response => new Reason(response),
    }),
    createReason: builder.mutation({
      query: ({ ...data }) => ({
        url: '/api/reasons/',
        method: 'POST',
        data,
      }),
      invalidatesTags: [REASON_TAG],
      transformResponse: response => new Reason(response),
    }),
    updateReason: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/reasons/${id}/`,
        method: 'PATCH',
        data,
      }),
      invalidatesTags: [REASON_TAG],
      transformResponse: response => new Reason(response),
    }),
    deleteReason: builder.mutation({
      query: id => ({
        url: `/api/reasons/${id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: [REASON_TAG],
    }),
  }),
});

export const {
  useListReasonsQuery,
  useFetchReasonQuery,
  useCreateReasonMutation,
  useUpdateReasonMutation,
  useDeleteReasonMutation,
} = valuePropositionReasonsApi;
